import * as React from 'react'
import * as Styles from './HomeRankingModule.style'
import {renderPopular, mta} from '@/utils/tools'
import {classes} from 'typestyle'
import globalBus from '@/services/Bus'
import {useGlobalBus} from '@/services/global-bus'
import {ImageView} from '../../ImageView/ImageView'
import { replaceWkDomain } from '../../../../../utils/tools'

interface IplayInfoType {
    status: string,
    operationID: string
}

declare const window: any

const ImageConfig = {
    0: require('./assets/images/排行榜_0.png'),
    1: require('./assets/images/排行榜_1.png'),
    2: require('./assets/images/排行榜_2.png')
}

export function HomeRankingModuleSpecial(props) {
    const invite_id = props.invite_id
    const content = props.data.contents
    const title = props.data.name
    const [playInfo, setPlayInfo] = React.useState<IplayInfoType>({status: 'PAUSE', operationID: '0'})
    let isAnniversary = false

    if (props.data.is_anniversary && props.data.is_anniversary === true) {
        isAnniversary = true
    }

    const operationAudio = (info, e, type) => {
        e.stopPropagation()
        mta(`main-listen-btn-click'}`)
        if (Number(playInfo.operationID) === info.content_id) { // 暂停

            if (type === 'pause') {
                globalBus.emit({
                    audioPlayerStatusChange: {
                        status: 'PAUSE',
                        operationID: info.content_id
                   }
               })
            } else {
                globalBus.emit({
                    audioPlayerStatusChange: {
                        status: 'PLAY',
                        operationID: info.content_id
                   }
               })
            }
            return
        }
        globalBus.emit({
            playerInfo: {
                lecture_url: isAnniversary ? `${window.location.origin}/activity/triennial/?id=${info.id}&inviter_id=${invite_id}&reduce=${info.return_money}` : info.url,
                url: info.listen_url,
                cover: info.cover,
                playId: info.content_id
            }
        })
    }

    useGlobalBus({
        audioPlayerStatusChange: (info) => {
            setPlayInfo(info)
        }
    })

    const renderPlayStatus = (id: number, details: any) => {
        if (playInfo.status === 'PLAY' && Number(playInfo.operationID) === id) {
            return (
                <div className={Styles.playBtn} onClick={(e) => operationAudio(details, e, 'pause')}>
                    <img src="https://static-cos.lycheer.net/picture/10490565_44a2dd6af77033cf8a7f851be4094028.jpg" alt=""/>
                    <i>暂停</i>
                </div>
            )
        } else {
            return (
            <div className={Styles.playBtn} onClick={(e) => operationAudio(details, e, 'play')}>
                 <img src="https://static-cos.lycheer.net/picture/10490565_b7c94067627a5f97f2b0a14a4d8e05be.jpg" alt=""/>
                 <i>试听</i>
            </div>
            )
        }
    }

    const LinkTo = (detail) => {
        if (isAnniversary) {
            if (detail.return_money === 0) {
                location.assign(replaceWkDomain(detail.url))
            } else {
                location.assign(`${window.location.origin}/activity/triennial/?id=${detail.id}&inviter_id=${invite_id}&reduce=${detail.return_money}`)
            }
        } else {
             location.assign(replaceWkDomain(detail.url))
        }
    }

    if (content.length > 0) {
        return (
            <div className="HomeRanking">
                {isAnniversary && (
                    <div className={Styles.activityHeader}/>
                )}
                <div className={isAnniversary && Styles.HomePictureViewInActivity}>
                <div className={Styles.title} style={{paddingBottom: isAnniversary && 0}}>{title}</div>
                <div className={classes(Styles.HomeRankingModule, isAnniversary && Styles.isActivity)}>

                    {content.length > 0 &&
                    <div className={Styles.HomeRankingContentWrap}  key={content[0].content_id} onClick={() => LinkTo(content[0])}>
                    <div className={Styles.HomeRankingContentLeft}>
                            <div className={Styles.HomeRankingCover}>
                                 <ImageView url={content[0].cover} width={400}/>
                                <img className={Styles.RankCoverTag} src={ImageConfig[0]} alt=""/>
                            </div>
                    </div>

                    <div className={Styles.HomeRankingContentRight}>
                            <div>
                                <span className={classes(Styles.HomeRankingContentRightTitle, 'TextChangeToTwoLines')}>
                                    {isAnniversary && (
                                        <span className={Styles.activitySpecialReturn}>返{content[0].return_money / 100}元</span>
                                    )}

                                    {content[0].title}
                                </span>
                            </div>

                            <div className={Styles.HomeRankingContentButton}>
                                <div className={Styles.popularNum}>
                                    <img src="https://static-cos.lycheer.net/picture/10490565_5ddfe21b03842fa68973218ec2737646.jpg" alt=""/>
                                    <p>{renderPopular(content[0].popular)}人</p>
                                </div>
                                {content[0].can_listen ? (
                                <div className={Styles.listenBtn}>
                                    {renderPlayStatus(content[0].content_id, content[0])}
                                </div>) : ''}
                            </div>
                    </div>
                    </div>}

                    {content.length > 2 &&
                    <div className={Styles.noramlRankList}>

                        {content.slice(1).map((item, index) => (
                            <div className={Styles.HomeRankingContentWrapNormal} key={item.content_id} onClick={() => LinkTo(item)}>
                                <div className={Styles.HomeRankingContentTop}>
                                    <div className={Styles.HomeRankingCoverNormal}>
                                        <ImageView url={item.cover} width={400}/>
                                        {index + 1 <= 2 && <img className={Styles.RankCoverTagNormal} src={ImageConfig[index + 1]} alt=""/>}
                                    </div>
                                </div>

                                <div className={Styles.HomeRankingContentBottom}>
                                    <div>
                                        <span className={classes(Styles.HomeRankingContentRightTitle, 'TextChangeToTwoLines')}>
                                            {isAnniversary && (
                                                <span className={Styles.activitySpecialReturn}>返{item.return_money / 100}元</span>
                                            )}
                                            {item.title}
                                        </span>
                                    </div>

                                    <div className={Styles.HomeRankingContentButton}>
                                        <div className={Styles.popularNum}>
                                            <img src="https://static-cos.lycheer.net/picture/10490565_5ddfe21b03842fa68973218ec2737646.jpg" alt=""/>
                                            <p>{renderPopular(item.popular)}人</p>
                                        </div>
                                        {item.can_listen ? (
                                        <div className={Styles.listenBtn}>
                                            {renderPlayStatus(item.content_id, item)}
                                        </div>) : ''}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>}
                  </div>
                </div>
            </div>
        )
    } else {
        return null
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/TriennialsSpecial/HomeRankingModule/HomeRankingModule.tsx